import { CommunityRepository } from '@amityco/ts-sdk';

export default useAutoJoinSocialPlusCommunity = _communityIds => {
  const communityIds = Array.isArray(_communityIds) ? _communityIds : [_communityIds];
  communityIds.forEach(communityId => {
    console.log(`Joining community ${communityId}`);
    CommunityRepository.getCommunity(communityId, ({ data, loading, error }) => {
      // Wait for the community to be loaded, then join if not already joined and there's no error
      if (loading || error || data.isJoined) return;
      CommunityRepository.joinCommunity(communityId);
    });
  });
};
